import React from 'react';

import { getEvents } from 'models/events';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/event',
	components: () => [import(/* webpackChunkName: 'event' */ './component')],
	render: ([Event]) => <Event />,
	onEnter: async ({ store }) => {
		console.log('on Enter Events');
		await store.dispatch(getEvents());
		console.log('on Enter Events / end');
	}
};

export default routes;
